/**
 * The chat's emoji picker: a fixed, curated set of common emoji rather than a library. They are
 * plain Unicode text, so they go into the message as typed characters and render with the
 * platform's own emoji font. Smileys first, then hands, hearts and celebrations, then the cards.
 */
export const CHAT_EMOJIS = [
	'😀',
	'😂',
	'🤣',
	'😊',
	'😍',
	'😘',
	'😎',
	'🤩',
	'😉',
	'🤔',
	'😅',
	'😢',
	'😭',
	'😡',
	'😱',
	'🥳',
	'😴',
	'🤗',
	'🙏',
	'👍',
	'👎',
	'👏',
	'🙌',
	'👋',
	'💪',
	'🤝',
	'❤️',
	'💔',
	'🔥',
	'🎉',
	'💯',
	'⭐',
	'🏆',
	'💰',
	'🍀',
	'🃏',
	'♠️',
	'♥️',
	'♦️',
	'♣️',
] as const;
